import { render, staticRenderFns } from "./PlaceholderPattern.vue?vue&type=template&id=50cec4a0&scoped=true&"
import script from "./PlaceholderPattern.vue?vue&type=script&lang=js&"
export * from "./PlaceholderPattern.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderPattern.vue?vue&type=style&index=0&id=50cec4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cec4a0",
  null
  
)

export default component.exports